import { render, staticRenderFns } from "./InstallmentsList.vue?vue&type=template&id=270d8b75&"
import script from "./InstallmentsList.vue?vue&type=script&lang=js&"
export * from "./InstallmentsList.vue?vue&type=script&lang=js&"
import style0 from "./InstallmentsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports